<template>
  <div>
    <b-form @submit.prevent="submit" novalidate>
      <div class="row">
        <div class="col-12">

          <validated-form-input name="dueDays" label="Maksetähtaeg päevades:" placeholder="Maksetähtaeg päevades"
                                v-model.number="days" validate="required|numeric|max_value:99" :validator="$validator"/>

        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <submit-button class="float-right" variant="primary">Salvesta</submit-button>
        </div>
      </div>
    </b-form>
  </div>

</template>

<script>
  import ValidatedFormInput from '@/components/ValidatedFormInput'
  import gateway from '@/services/gateway'

  export default {
    props: ['invoice'],
    components: {ValidatedFormInput},
    data() {
      return {
        days: 0
      }
    },
    methods: {
      submit() {
        this.$validator.validateAll().then((valid) => {
          if (!valid) return
          gateway.post(`/invoices/${this.invoice.id}/due-days`, {days: this.days}).then(() => this.$emit('done'))
        })
      },
    },
    created() {
      this.days = this.invoice.paymentDueDays || 10
    }
  }
</script>
